import { useState } from "react";
import { useParams } from "react-router-dom";
import { Form, Button, Container, Alert } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const UpdateTracking = () => {
  const { orderId, customerId } = useParams(); 
  const navigate = useNavigate();

  const [trackingStatus, setTrackingStatus] = useState("processing");
  const [note, setNote] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");

    if (!orderId || !customerId) {
      setError("Missing order or customer ID.");
      return;
    }
  const token = localStorage.getItem("admin_token"); 
 
    try {
      const res = await axios.post(`${API_BASE}/api/orders_a/trackings/update`, {
        order_id: orderId,
        customer_id: customerId,
        tracking_status: trackingStatus,
        note,
      },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      });

      setSuccess("Tracking status updated successfully.");
      setTimeout(() => {
        navigate("/admin/manageOrders");
      }, 1000);
    } catch (err) {
      console.error(err);
      setError("Failed to update tracking status.");
    }
  };

  return (
    <Container className="mt-4">
      <h3>Update Tracking for Order #{orderId}</h3>

      {success && <Alert variant="success">{success}</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Tracking Status</Form.Label>
          <Form.Select
            value={trackingStatus}
            onChange={(e) => setTrackingStatus(e.target.value)}
            required
          >
            <option value="processing">Processing</option>
            <option value="delivered">Delivered</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Tracking Note</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Optional note about the tracking update"
          />
        </Form.Group>

        <Button type="submit">Update Tracking</Button>
      </Form>
    </Container>
  );
};

export default UpdateTracking;
